// 사용자 회원 등급 API 래퍼.

import { api } from "@/api/client.ts";

export interface MembershipView {
  tier: { key: string; name: string };
  windowMonths: number;
  windowSpentKrw: number;
  nextTier: { name: string; minSpendKrw: number; remainingKrw: number } | null;
  // 회원 등급 기능 사용 여부. false 면 마이페이지에서 등급을 노출하지 않는다(개선 4).
  tierEnabled: boolean;
}

// 내 멤버십(등급/실적) 조회.
export async function getMembership(): Promise<MembershipView> {
  const data = await api.get<{ membership: MembershipView }>("/me/membership");
  return data.membership;
}
